import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface ScrollRevealProps {
  children: ReactNode;
  width?: 'fit-content' | '100%';
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right';
  className?: string;
}
export function ScrollReveal({
  children,
  width = '100%',
  delay = 0,
  direction = 'up',
  className = ''
}: ScrollRevealProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-10% 0px'
  });
  const getDirectionOffset = () => {
    switch (direction) {
      case 'up':
        return {
          y: 50,
          x: 0
        };
      case 'down':
        return {
          y: -50,
          x: 0
        };
      case 'left':
        return {
          x: 50,
          y: 0
        };
      case 'right':
        return {
          x: -50,
          y: 0
        };
      default:
        return {
          y: 50,
          x: 0
        };
    }
  };
  const offset = getDirectionOffset();
  return <div ref={ref} style={{
    width
  }} className={className} data-id="element-198">
      <motion.div variants={{
      hidden: {
        opacity: 0,
        ...offset
      },
      visible: {
        opacity: 1,
        x: 0,
        y: 0
      }
    }} initial="hidden" animate={isInView ? 'visible' : 'hidden'} transition={{
      duration: 0.6,
      delay,
      ease: 'easeOut'
    }} data-id="element-199">
        {children}
      </motion.div>
    </div>;
}